import { render, staticRenderFns } from "./CompanyNavigation.vue?vue&type=template&id=968a6abc"
import script from "./CompanyNavigation.vue?vue&type=script&lang=js"
export * from "./CompanyNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports